export default "__VITE_ASSET__CwmkXI8P__"